import yletv1Logo from './assets/yle-tv1.png'
import yletv2Logo from './assets/yle-tv2.png'
import yleteemafemLogo from './assets/yle-teemafem.png'
import tv5Logo from './assets/tv5.png'
import subLogo from './assets/sub.png'
import livLogo from './assets/liv.png'
import kutonenLogo from './assets/kutonen.png'
import jimLogo from './assets/jim.png'
import nelonenLogo from './assets/nelonen.png'
import avaLogo from './assets/ava.png'
import friiLogo from './assets/frii.png'
import mtv3Logo from './assets/mtv3.png'
import alfaLogo from './assets/alfatv.png'
import heroLogo from './assets/hero.png'
import estradiLogo from './assets/estradi.png'
import nationalgeographicLogo from './assets/natgeo.png'
import tlcLogo from './assets/tlc.png'
import starchannelLogo from './assets/starchannel.png'
import eveoLogo from './assets/eveo.png'

export const channelThemes = {
  colors: {
    yletv1hd: '#6FA0FF',
    yletv2hd: '#B134F5',
    yleteemafemhd: '#BCD61D',
    tv5hd: '#B5B5B5',
    mtvsubhd: '#EBD40F',
    livhd: '#00E000',
    kutonenhd: '#87E3D8',
    jimhd: '#F7F263',
    nelonenhd: '#5570F5',
    mtvavahd: '#853D60',
    friihd: '#C2485A',
    mtv3hd: '#E43112',
    alfatv: '#A42F12',
    herohd: '#DF9387',
    estradi: '#CA005D',
    nationalgeographichd: '#fbdc3a',
    tlc: '#ed697b',
    eveohd: '#36e7df',
    starchannel: '#d6d6d6',
  },
  logos: {
    yletv1hd: yletv1Logo,
    yletv2hd: yletv2Logo,
    yleteemafemhd: yleteemafemLogo,
    tv5hd: tv5Logo,
    mtvsubhd: subLogo,
    livhd: livLogo,
    kutonenhd: kutonenLogo,
    jimhd: jimLogo,
    nelonenhd: nelonenLogo,
    mtvavahd: avaLogo,
    friihd: friiLogo,
    mtv3hd: mtv3Logo,
    alfatv: alfaLogo,
    herohd: heroLogo,
    estradi: estradiLogo,
    nationalgeographichd: nationalgeographicLogo,
    tlc: tlcLogo,
    starchannel: starchannelLogo,
    eveohd: eveoLogo,
  }
};
